import { render } from "./GenericButton.vue?vue&type=template&id=2ff64dc9&scoped=true"
import script from "./GenericButton.vue?vue&type=script&lang=js"
export * from "./GenericButton.vue?vue&type=script&lang=js"

import "./GenericButton.vue?vue&type=style&index=0&id=2ff64dc9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff64dc9"]])

export default __exports__